// Shared types and constants for MDR paginated list stores.

export interface MdrSortState {
  by: string;
  order: 'asc' | 'desc';
}

/**
 * Filter fields common to both manage and history tabs. Strategy-specific
 * stores extend this with their own fields.
 */
export interface MdrSharedFilters {
  ships?: string[];
  passenger_name?: string;
  date_from?: string;
  date_to?: string;
  cabin?: string;
}

export const DEFAULT_SORT: MdrSortState = { by: 'request_datetime', order: 'desc' };
export const DEFAULT_PAGE_SIZE = 20;

/**
 * Max pages kept in the per-store LRU cache. With pageSize=20 this caps
 * cache footprint at ~200 rows — negligible while comfortably covering
 * typical browse sessions in both directions.
 */
export const PAGE_CACHE_MAX_PAGES = 10;
